<template>
  <div>
    <div class="d_content_list" v-if="!isMobile">
      <div
        class="content_item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item.id)"
      >
        <div class="content_item_img">
          <img v-lazy="item.coverImg" />
        </div>
        <div class="content_item_title">
          <p class="title">{{ item.title }}</p>
          <p class="desc">{{ item.details.theater }}</p>
          <p class="desc">{{ item.details.artisticForm }}</p>
          <p class="desc">
            {{ $t('director') }}&nbsp;&nbsp;{{ item.details.director }}
          </p>
          <div class="content_item_d">
            <div class="item_d">
              <div class="item_d_l">
                <img src="../../../assets/img/time_icon.png" />{{ $t('time') }}
              </div>
              <div class="item_d_r">
                {{ item.details.performanceTime }}
                <!-- {{ item.startTime + ' | ' + item.endTime }} -->
              </div>
            </div>
            <div class="item_d">
              <div class="item_d_l">
                <img src="../../../assets/img/site_icon.png" />{{ $t('site') }}
              </div>
              <div class="item_d_r">{{ item.details.site }}</div>
            </div>
            <div class="item_d">
              <div class="item_d_l">
                <img src="../../../assets/img/duration_icon.png" />{{
                  $t('duration')
                }}
              </div>
              <div class="item_d_r">
                {{ item.details.duration }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_list" v-else>
      <div
        class="content_item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item.id)"
      >
        <div class="content_item_u">
          <div class="content_item_img">
            <img v-lazy="item.img" />
          </div>
          <div class="content_item_title">
            <p class="title">{{ item.title }}</p>
            <p class="desc">{{ item.details.theater }}</p>
            <p class="desc">{{ item.details.artisticForm }}</p>
            <p class="desc">
              {{ $t('director') }}&nbsp;&nbsp;{{ item.details.director }}
            </p>
          </div>
        </div>
        <div class="content_item_d">
          <div class="item_d">
            <div class="item_d_l">
              <img src="../../../assets/img/time_icon.png" />{{ $t('time') }}
            </div>
            <div class="item_d_r">
              {{ item.details.performanceTime }}
              <!-- {{ item.startTime + ' | ' + item.endTime }} -->
            </div>
          </div>
          <div class="item_d">
            <div class="item_d_l">
              <img src="../../../assets/img/site_icon.png" />{{ $t('site') }}
            </div>
            <div class="item_d_r">{{ item.details.site }}</div>
          </div>
          <div class="item_d">
            <div class="item_d_l">
              <img src="../../../assets/img/duration_icon.png" />{{
                $t('duration')
              }}
            </div>
            <div class="item_d_r">{{ item.details.duration }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchConentList } from '@/assets/api';
import responsiveMixin from '@/mixins/responsiveMixin';
export default {
  mixins: [responsiveMixin],
  props: {
    cloumnId: {
      type: String,
      default: '',
    },
    cloumnLeftId: {
      type: String,
      default: '',
    },
  },
  data() {
    return { list: [] };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      const data = {
        columnIds: this.cloumnLeftId,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.list = res.records;
      });
    },
    toDetail(id) {
      this.$router.push({
        path: `/dreamDramaDetail?id=${id}&cloumnId=${this.cloumnId}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.d_content_list {
  .content_item {
    width: 33%;
    flex: 0 0 calc((100% - 40px) / 3);
    text-align: left;
    margin: 0 20px 20px 0;
    overflow: hidden;
    background: rgba(255, 255, 255, 0);
    border: 6px solid rgba(255, 255, 255, 0);
    &:nth-child(3n) {
      /* 去除第3n个的margin-right */
      margin-right: 0;
    }
    &:hover {
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      border: 6px solid;
      border-image: linear-gradient(
          90deg,
          rgba(170, 229, 239, 1),
          rgba(177, 187, 255, 1)
        )
        6 6;
    }
    .content_item_img {
      img {
        width: 100%;
        height: 350px;
        object-fit: cover;
      }
    }
    .content_item_title {
      padding: 1rem 0.3125rem 0.3125rem;
      background: #fff;
      .title {
        font-size: 1.125rem;
        color: #333;
        display: -webkit-box; /* 旧版 Flex 布局 */
        -webkit-line-clamp: 2; /* 限制行数 */
        -webkit-box-orient: vertical; /* 垂直排列 */
        overflow: hidden; /* 隐藏溢出 */
        text-overflow: ellipsis;
        padding: 0 1.25rem;
      }
      .desc {
        font-size: 0.875rem;
        color: #6b6d7a;
        display: -webkit-box; /* 旧版 Flex 布局 */
        -webkit-line-clamp: 2; /* 限制行数 */
        -webkit-box-orient: vertical; /* 垂直排列 */
        overflow: hidden; /* 隐藏溢出 */
        text-overflow: ellipsis;
        margin: 0.375rem 0;
        padding: 0 0.625rem;
      }
      .content_item_d {
        margin-top: 0.625rem;
        background: #f6f6f6;
        padding: 0.3125rem 0.625rem;
        .item_d {
          display: flex;
          justify-content: flex-start;
          font-size: 0.875rem;
          margin: 0.3125rem 0;
          .item_d_l {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            font-family: SourceHanSansCN-Medium;
            width: 3.25rem;
            img {
              width: 1.25rem;
              height: 1.25rem;
            }
          }
          .item_d_r {
            flex: 1;
            display: inline-block;
            color: #6b6d7a;
            margin-left: 0.3125rem;
          }
        }
      }
    }
  }
}
.content_list {
  .content_item {
    flex: 0 0 calc((100% - 40px) / 3);
    text-align: left;
    margin-bottom: 1.6667rem;
    overflow: hidden;
    background: rgba(255, 255, 255, 0);
    border: 6px solid rgba(255, 255, 255, 0);

    .content_item_u {
      display: flex;
      background: #f0f1f2;
      .content_item_img {
        width: 27.8%;
        img {
          width: 100%;
          height: 10.0833rem;
          object-fit: cover;
        }
      }
      .content_item_title {
        flex: 1;
        padding: 1rem 0.3125rem 0.3125rem;
        background: #f0f1f2;
        .title {
          font-size: 1.1667rem;
          color: #333;
          display: -webkit-box; /* 旧版 Flex 布局 */
          -webkit-line-clamp: 2; /* 限制行数 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          overflow: hidden; /* 隐藏溢出 */
          text-overflow: ellipsis;
          padding: 0 1.25rem;
          font-family: SourceHanSansCN-Medium;
        }
        .desc {
          font-size: 0.8333rem;
          color: #6b6d7a;
          display: -webkit-box; /* 旧版 Flex 布局 */
          -webkit-line-clamp: 2; /* 限制行数 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          overflow: hidden; /* 隐藏溢出 */
          text-overflow: ellipsis;
          margin: 0.375rem 0;
          padding: 0 1.25rem;
        }
      }
    }

    .content_item_d {
      margin-top: 0.625rem;
      padding: 0.3125rem 1.3333rem;
      .title {
        font-size: 1.1667rem;
        color: #333;
        display: -webkit-box; /* 旧版 Flex 布局 */
        -webkit-line-clamp: 2; /* 限制行数 */
        -webkit-box-orient: vertical; /* 垂直排列 */
        overflow: hidden; /* 隐藏溢出 */
        text-overflow: ellipsis;
        margin-bottom: 12px;
        font-family: SourceHanSansCN-Medium;
      }
      .item_d {
        display: flex;
        justify-content: flex-start;
        font-size: 0.8333rem;
        margin: 0.3125rem 0;
        .item_d_l {
          display: flex;
          align-items: center;
          font-family: SourceHanSansCN-Medium;
          img {
            width: 1.25rem;
            height: 1.25rem;
          }
        }
        .item_d_r {
          display: inline-block;
          color: #6b6d7a;
          margin-left: 0.3125rem;
        }
      }
    }
  }
}
</style>
